import gsap from 'gsap'

export default class Video {
  constructor() {
    this._getElems()
    this._init()
    this._events()
  }

  _getElems() {
    this.videos = Array.from(document.querySelectorAll('[data-modal-open]')).map((container) => ({
      container,
      videoPlay: container.querySelector('.e-play'),
      videoModal: container.querySelector('.e-video-modal'),
      video: container.querySelector('video') || container.querySelector('iframe'),
      tlSidebarVideo: null
    }))

    this.classicVideos = Array.from(document.querySelectorAll('[data-classic-video]')).map((container) => ({
      videoPlay: container.querySelector('.e-play'),
      video: container.querySelector('video'),
      poster: container.querySelector('.image')
    }))
  }

  _init() {
    if (this.videos) {
      this.videos.forEach((item) => {
        gsap.set(item.video, {
          zIndex: 1
        })
  
        gsap.set(item.videoModal, {
          visibility: 'hidden',
          opacity: 0
        })
  
        gsap.set(item.video, {
          yPercent: 25,
          opacity: 0,
          scale: 0.8
        })
  
        const tl = gsap.timeline({
          paused: true,
          defaults: {
            duration: 1,
            ease: 'power3.out'
          }
        })
  
        tl.to(item.video, {
          zIndex: 500,
          duration: 0
        })
  
        tl.to(item.videoModal, {
          visibility: 'visible',
          duration: 0
        })
  
        tl.to(item.videoModal, {
          opacity: 1
        })
  
        tl.to(item.video, {
          yPercent: 0,
          opacity: 1,
          scale: 1
        }, '<+0.4')
  
        item.tlSidebarVideo = tl
      })
    }
  }

  _events() {
    if (this.classicVideos) {
      this.classicVideos.forEach((item) => {
        item.videoPlay.addEventListener('click', () => {
          if (item.poster) {
            gsap.to(item.poster, {
              autoAlpha: 0,
              onComplete: () => {
                gsap.set(item.poster, {
                  visibility: 'hidden'
                })
              }
            })
          }

          gsap.to(item.videoPlay, {
            autoAlpha: 0,
            onComplete: () => {
              gsap.set(item.poster, {
                visibility: 'hidden'
              })
            }
          })

          if (item.video) {
          item.video.play()
          }
        })
      })
    }

    if (this.videos) {
      this.videos.forEach((item) => {
        item.videoPlay.addEventListener('click', () => {
          document.querySelector('header').classList.add('--scroll')
          item.tlSidebarVideo.play()
        })

        item.videoModal.addEventListener('click', (event) => {
          if (!item.video.contains(event.target)) {
            item.tlSidebarVideo.reverse()
            item.video.currentTime = 0
            item.video.pause()
            document.querySelector('header').classList.remove('--scroll')
          }
        })

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            item.tlSidebarVideo.reverse()
            item.video.pause()
            document.querySelector('header').classList.remove('--scroll')
          }
        })
      })
    }
  }

  _resetVideo(item) {
    if (item.querySelector('video')) {
      item.querySelector('video').currentTime = 0
      item.querySelector('video').pause()
    }

    if (item.querySelector('.image')) {
      gsap.set(item.querySelector('.image'), {
        opacity: 1,
        visibility: 'visible'
      })
    }

    if (item.querySelector('.e-play')) {
      gsap.set(item.querySelector('.e-play'), {
        opacity: 1,
        visibility: 'visible'
      })
    }
  }
}
